import dayjs from "dayjs";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { blue } from "@ant-design/colors";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetXAILeads } from "@lib/api/xAI";
import { FaUsers } from "react-icons/fa";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";
import { ROUTES } from "@lib/constants";

type Props = {
  cardProps?: AppCardProps;
};

export default function TftSalesLeadsMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["dashboard-minicard-tft-sales-leads"],
    queryFn: () =>
      apiGetXAILeads({
        sort: "createdAt,DESC",
        limit: 10000,
      }),
  });

  const apiData = data?.data?.data;
  const total = apiData?.length || 0;

  const todayTotal =
    apiData?.filter((d) => {
      const createdAt = dayjs(d.createdAt);
      const startOfToday = dayjs().startOf("day");
      const endOfToday = dayjs().endOf("day");

      return createdAt.isBetween(startOfToday, endOfToday, null, "[]");
    })?.length || 0;

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.TFT_SALES.LEAD_LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <FaUsers />,
        color: blue[5],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["sidebar.tftSalesLeads"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: todayTotal,
            duration: messages["common.today"] as string,
          },
        },
      }}
    />
  );
}
